import React, { Suspense } from "react";

import { Provider } from "react-redux";
import { Redirect, Route, Switch, useRouteMatch } from "react-router";
import BasicLoading from "ZeroRuby/BasicLoading";

import PartnerProvider from "Common/PartnerProvider";
import { useSiteConfig } from "Common/Redux/siteConfig";
import ScrollToTop from "Common/ScrollToTop";
import { ThemeProvider } from "Theme/Context";

import Chrome from "./components/Chrome";
import PlansPage from "./pages/PlansPage";
import ProcessingPlansPage from "./pages/ProcessingPlansPage";
import { createStore, useGetBenAdminOpenEnrollmentSetupQuery } from "./redux";

const LoadingPage = () => (
  <Chrome>
    <BasicLoading />
  </Chrome>
);

const useData = () => {
  const { isLoading: isLoadingSiteConfig, data: _siteConfig } = useSiteConfig();
  const { isLoading: isLoadingBenAdminOpenEnrollmentSetup, data: benAdminOpenEnrollmentSetup } = useGetBenAdminOpenEnrollmentSetupQuery(null);
  const { path } = useRouteMatch();
  let nextPageUrl = `${path}/plans`;
  if (benAdminOpenEnrollmentSetup?.status === "processing") {
    nextPageUrl = `${path}/processing-plans`;
  } else if (benAdminOpenEnrollmentSetup?.status === "launched") {
    // TODO(ben-admin-renewal): Redirect to BenAdminRenewal
    nextPageUrl = "/employer-dashboard";
  }

  return {
    isLoading: isLoadingSiteConfig || isLoadingBenAdminOpenEnrollmentSetup,
    nextPageUrl,
  };
};

const Routes = () => {
  const { path } = useRouteMatch();
  const { isLoading, nextPageUrl } = useData();
  return isLoading ? (
    <LoadingPage />
  ) : (
    <Suspense fallback={<LoadingPage />}>
      <Switch>
        <Route path={`${path}`} exact>
          <Redirect to={nextPageUrl} />
        </Route>
        <Route path={`${path}/plans`} exact>
          {(props) => <PlansPage {...props} />}
        </Route>
        <Route path={`${path}/processing-plans`} exact>
          {(props) => <ProcessingPlansPage {...props} />}
        </Route>
      </Switch>
    </Suspense>
  );
};

const App = () => {
  const store = createStore({});

  return (
    <Provider store={store}>
      <PartnerProvider>
        <ThemeProvider>
          <ScrollToTop>
            <Routes />
          </ScrollToTop>
        </ThemeProvider>
      </PartnerProvider>
    </Provider>
  );
};

export default App;
